import { Component } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-community';

interface PersonCellParams extends ICellRendererParams {
  value: any;
  showName?: boolean;
  showLinkedin?: boolean;
  showLocation?: boolean;
}

@Component({
    selector: 'app-person-cell',
    template: `
    <div class="person-cell-container">
      <div class="person-cell tw-text-base tw-flex tw-flex-col tw-mt-2 tw-mb-2">
        <div class="main-info tw-flex tw-flex-col">
          <div *ngIf="showName" class="name tw-flex tw-items-center tw-gap-2 tw-h-7 tw-text-gray-600 dark:tw-text-gray-300">
            <mat-icon
              class="tw-text-gray-500 dark:tw-text-gray-500 tw-flex-shrink-0 tw-text-[20px] tw-h-[20px] tw-w-[20px]">
              account_circle_outline
            </mat-icon>
            <span class="tw-font-semibold">{{ name }}</span>
          </div>

          <div *ngIf="!showName" class="tw-flex tw-items-center tw-gap-6">
            <div class="left-side tw-flex tw-flex-col tw-gap-2">
              <div class="tw-flex tw-items-center tw-gap-2">
                <mat-icon
                  class="tw-text-gray-500 tw-flex-shrink-0 tw-text-[20px] tw-h-[20px] tw-w-[20px]">
                  account_circle_outline
                </mat-icon>
                <span class="tw-font-semibold tw-text-gray-600 dark:tw-text-gray-300">Name</span>
              </div>
              <div class="tw-flex tw-items-center tw-gap-2 tw-text-sm tw-text-gray-600 dark:tw-text-gray-300">
                <mat-icon class="tw-text-gray-500 tw-h-5 tw-w-5 tw-text-[20px]"> public </mat-icon>
                <span>Location</span>
              </div>
              <div class="tw-flex tw-items-center tw-gap-2 tw-text-sm tw-text-gray-600 dark:tw-text-gray-300">
                <img class="custom-icon tw-h-5 tw-w-5" src="assets/icons/linkedin.svg" />
                <span>LinkedIn</span>
              </div>
            </div>
            <div class="right-side">
              <div
                class="tw-bg-yellow-200 tw-text-yellow-800 tw-border tw-border-solid tw-border-yellow-300 dark:tw-border-yellow-700 tw-text-xs tw-font-semibold tw-mr-2 tw-px-2.5 tw-py-0.5 tw-rounded-2xl dark:tw-bg-yellow-200 dark:tw-text-yellow-900 dark:tw-bg-opacity-80 tw-flex tw-items-center tw-gap-1 tw-mt-2">
                <mat-icon class="tw-text-yellow-800 tw-w-4 tw-h-4 tw-text-[15px]">lock</mat-icon>
                Unlock
              </div>
            </div>
          </div>

          <div *ngIf="showLocation && (country || location)" class="location tw-flex tw-items-center tw-text-sm tw-text-gray-500 dark:tw-text-gray-400 tw-h-7">
            <span>{{ country }}</span>
            <span *ngIf="country && location" class="tw-mr-1">, </span>
            <span *ngIf="location">{{ location }}</span>
          </div>

        <div *ngIf="showLinkedin && linkedin" class="tw-text-sm tw-h-7 tw-flex tw-items-center">
          <img class="custom-icon tw-h-5 tw-w-5 tw-mr-2" src="assets/icons/linkedin.svg" />
          <a class="hover:tw-underline tw-underline-offset-2" [href]="linkedinUrl" target="_blank" rel="noopener noreferrer">{{linkedin}}</a>
        </div>
      </div>
    </div>
  `,
    styles: [
        `
    .person-cell-container {
      container-type: inline-size;
      .name {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    `,
    ],
    standalone: false
})
export class PersonCellComponent {
  private person: any;
  showName: boolean = true;
  showLinkedin: boolean = true;
  showLocation: boolean = true;

  agInit(params: PersonCellParams): void {
    this.person = params.data;
    this.showName = params.showName !== false; // Default to true if not specified
    this.showLinkedin = params.showLinkedin !== false; // Default to true if not specified
    this.showLocation = params.showLocation !== false; // Default to true if not specified
  }

  refresh(params: PersonCellParams): boolean {
    this.agInit(params);
    return true;
  }

  get name(): string {
    return this.person?.name || '';
  }

  get country(): string {
    return this.person?.country || '';
  }

  get location(): string {
    return this.person?.location || '';
  }

  get linkedin(): string {
    return this.person?.linkedin || '';
  }

  get linkedinUrl(): string {
    return this.linkedin ? `https://www.linkedin.com/in/${this.linkedin}` : '';
  }
}
